import { useEffect, useState } from 'react';
import getMemberShipAndLoyaltyCountries from 'src/v3/pages/Signup/getMemberShipAndLoyaltyCountries';
import { CountryCode } from '../../api/fetchLanguages';
import { Tenant } from '../../utils/configurations';

export const fallbackLanguage: InterfaceLanguage = 'en';
export type InterfaceLanguage =
  | 'en'
  | 'de'
  | 'it'
  | 'fr'
  | 'nl'
  | 'cs'
  | 'es'
  | 'pl';

const useAvailableLanguages = (
  country: CountryCode | null,
  tenant: Tenant
): {
  defaultLanguage?: InterfaceLanguage;
  availableLanguages: InterfaceLanguage[];
  loading: boolean;
} => {
  const [availableLanguages, setAvailableLanguages] = useState<
    InterfaceLanguage[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [language, setLanguage] = useState<InterfaceLanguage | undefined>();

  useEffect(() => {
    const loadLanguages = async () => {
      const uniqueLanguages = new Set<InterfaceLanguage>();
      uniqueLanguages.add(fallbackLanguage);

      try {
        const membershipCountries = await getMemberShipAndLoyaltyCountries();
        const currentCountry = membershipCountries.find(
          (item) => item.code === country
        );

        const hasOneLanguage = currentCountry?.language.length === 1;

        const defaultLanguage = hasOneLanguage
          ? currentCountry.language[0].code
          : currentCountry?.language.find((l) => l.default)?.code ??
            fallbackLanguage;

        membershipCountries
          .flatMap((item) => item.language)
          .forEach((item) => {
            uniqueLanguages.add(item.code as InterfaceLanguage);
          });

        setLanguage(defaultLanguage as InterfaceLanguage);
      } catch (e) {
        setLanguage(fallbackLanguage);
      }

      setLoading(false);
      setAvailableLanguages(Array.from(uniqueLanguages));
    };

    if (country) {
      loadLanguages();
    }
  }, [country, tenant]);

  return { defaultLanguage: language, availableLanguages, loading };
};

export default useAvailableLanguages;
